export default __webpack_public_path__ + "static/media/_2.6eccd6f9.png";